import { useEffect, useState } from "react";
import { subDays, format } from "date-fns";
import { useNavigate } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import APIAxios from "../../Api/APIAxios";
import SessaoAuth from "../../Hooks/SessaoAuth";
import Copyright from "../../components/Layout/Copyright";
import {
  Grid,
  Paper,
  Avatar,
  Typography,
  TextField,
  Button,
  CssBaseline,
  Box,
  Stack,
  Alert,
  CircularProgress,
  IconButton,
  useMediaQuery,
  InputAdornment,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import LockOutlinedIcon from "@mui/icons-material/Lock";


const defaultTheme = createTheme();
const LOGIN_URL = "/login";

export default function Login() {
  const { sessao, setSessao } = SessaoAuth();
  const isMobile = useMediaQuery(defaultTheme.breakpoints.down("sm"));

  const [form, setForm] = useState({ email: "", senha: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const Logosys = new URL("../../assets/logosys_brisiq.png", import.meta.url).href;
  const logo = new URL("../../assets/brisiq_vision_at.png", import.meta.url).href;

  const apiAxios = APIAxios();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await apiAxios.post(LOGIN_URL, JSON.stringify(form));

      const { token, status, nome, tipo, tokenEmpresa, modulos, datAceite } = response.data.data;

      const now = new Date();
      const startDate = subDays(now, 15);
      const endDate = now;

      setSessao({
        authToken: token,
        userEmail: form.email,
        userInfo: nome,
        userStatus: status,
        dataIni: format(startDate, "dd/MM/yyyy"),
        dataFim: format(endDate, "dd/MM/yyyy"),
        tipoUsuario: tipo,
        tokenEmpresa: tokenEmpresa,
        datAceite: datAceite === "" ? null : datAceite,
        modulos: modulos,
        rowsPerPage: 10,
      });

      navigate("/dashboard-geral");
    } catch (err) {
      if (!err.response) {
        setError("Servidor não responde");
      } else if (err.response.status === 400 || err.response.status === 401) {
        setError("Usuário ou Senha inválido!");
      } else {
        setError("Erro desconhecido.");
      }
    }
    setLoading(false);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <Grid container component="main" sx={{ height: "100vh" }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: `url(${Logosys})`,
            backgroundColor: (t) =>
              t.palette.mode === "light"
                ? t.palette.grey[50]
                : t.palette.grey[900],
            backgroundSize: "cover",
            backgroundPosition: "left",
          }}
        />
        <Grid
          item
          xs={12}
          sm={8}
          md={5}
          component={Paper}
          elevation={6}
          square
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            px: { xs: 3, sm: 6 },
          }}
        >
          {isMobile && (
            <Box
              component="img"
              src={logo}
              alt="Logo Faro IT"
              sx={{ mb: 5, width: "50%" }}
            >
            </Box>
          )}
          <Box
            sx={{
              width: "100%",
              maxWidth: 400,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: "#00597A" }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Identifique-se
            </Typography>
            {error && (
              <Stack sx={{ width: "100%" }} spacing={1}>
                <Alert severity="error">{error}</Alert>
              </Stack>
            )}
            <Box
              component="form"
              noValidate
              onSubmit={handleLogin}
              sx={{ mt: 1 }}
            >
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                label="E-mail"
                name="email"
                value={form.email}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                label="Senha"
                type={showPassword ? "text" : "password"}
                name="senha"
                value={form.senha}
                onChange={handleChange}
                //InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      sx={{
                        width: "12%",
                        display: "flex",
                        justifyContent: "space-around",
                      }}
                    >
                      <IconButton onClick={togglePasswordVisibility} edge="end">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                autoComplete="new-password"
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{
                  mt: 3,
                  mb: 2,
                  position: "relative",
                  backgroundColor: "#00597A",
                  color: "#fff",
                }}
              >
                Entrar
                {loading && (
                  <CircularProgress
                    size={35}
                    sx={{
                      color: "#dcdcdc",
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      zIndex: 1,
                    }}
                  />
                )}
              </Button>
            </Box>
            <Button
              variant="text"
              onClick={() => navigate("/senha")}
              sx={{ color: "#00597A", textTransform: "none" }}
            >
              Lembrar Senha
            </Button>
            <Copyright sx={{ mt: 5 }} />
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
